import dayjs, { type Dayjs } from 'dayjs'
import { PDateRangePickerFastChoice } from '../../../date-range-picker/types'

export type ResolvedDateRange = {
  from: Dayjs
  to: Dayjs
}

export const resolveDateRangeFastChoice = (
  choice: PDateRangePickerFastChoice,
): ResolvedDateRange => {
  const now: Dayjs = dayjs().tz()

  switch (choice) {
    case PDateRangePickerFastChoice.YESTERDAY:
      return unitRange(now.subtract(1, 'day'), 'day')
    case PDateRangePickerFastChoice.TODAY:
      return unitRange(now, 'day')
    case PDateRangePickerFastChoice.TOMORROW:
      return unitRange(now.add(1, 'day'), 'day')
    case PDateRangePickerFastChoice.LAST_WEEK:
      return unitRange(now.subtract(1, 'week'), 'week')
    case PDateRangePickerFastChoice.THIS_WEEK:
      return unitRange(now, 'week')
    case PDateRangePickerFastChoice.NEXT_WEEK:
      return unitRange(now.add(1, 'week'), 'week')
    case PDateRangePickerFastChoice.LAST_MONTH:
      return unitRange(now.subtract(1, 'month'), 'month')
    case PDateRangePickerFastChoice.THIS_MONTH:
      return unitRange(now, 'month')
    case PDateRangePickerFastChoice.NEXT_MONTH:
      return unitRange(now.add(1, 'month'), 'month')
    case PDateRangePickerFastChoice.LAST_YEAR:
      return unitRange(now.subtract(1, 'year'), 'year')
    case PDateRangePickerFastChoice.THIS_YEAR:
      return unitRange(now, 'year')
    case PDateRangePickerFastChoice.NEXT_YEAR:
      return unitRange(now.add(1, 'year'), 'year')
  }
}

const unitRange = (date: Dayjs, unit: 'day' | 'week' | 'month' | 'year'): ResolvedDateRange => ({
  from: date.startOf(unit),
  to: date.endOf(unit),
})
